// AHPS flood category colors.
//
// The different stages.
export const MajorColor = '204, 51, 255'
export const ModerateColor = '255, 0,   0'
export const MinorColor = '255, 153, 0'
export const ActionColor = '255, 255, 0'
export const RecordColor = '218, 234, 246'
export const LowColor = '144, 99, 32'
export const NoneColor = '46, 255, 65'
export const UnknownColor = '114, 175, 233'
